import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'kotahi-selects-linescape-sailing-schedules-api',
  template: require('./kotahi-selects-linescape-sailing-schedules-api.html'),
  styles: [require('./../blog.component.scss'), require('./kotahi-selects-linescape-sailing-schedules-api.scss')]
})
export class KotachiSelectsLinescapeSailingSchedulesApi extends BlogPage {
  title = "Kotahi selects Linescape’s Sailing Schedules API";
  description = "Linescape was selected by Kotahi Logistics, New Zealand, to provide consolidated sailing schedules to the Kotahi through Linescape’s API for their supply chain collaboration with customers.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/kotahi-selects-linescape-sailing-schedules-api/kotahi-selects-linescape-sailing-schedules-api.ts